<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Fleet Users</h1>

<div>
    <!-- Loading -->
    <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

    <p>Fleet Users for CustomerId: {{customerId}}</p>
    <!-- Fleet User -->
    <div class="ag-grid-container">
        <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="fleetUsersGridOptions">
        </ag-grid-angular>
    </div>
    <!-- Create, Update,  Delete Fleet User -->
    <div class="button-div">
        <button class="button-action" mat-raised-button color="primary" (click)="onCreateFleetUser()"
            [disabled]="canCreateFleetUser()">
            <mat-icon>open_in_new</mat-icon>
            Create Fleet User
        </button>
        <button class="button-action" mat-raised-button color="warn" (click)="deleteFleetUser()"
            [disabled]="canDeleteFleetUser()">
            <mat-icon>delete_forever</mat-icon>
            Delete Fleet User
        </button>
        <button mat-raised-button class="button-action" (click)="onUpdateFleetUser()"
            [disabled]="canUpdateFleetUser()">
            <mat-icon>open_in_new</mat-icon>
            Update Fleet User
        </button>
    </div>

    <!-- Selected Fleet User -->
    <div *ngIf="selectedFleetUser">
        <p>
            <strong>Fleet User Id: {{selectedFleetUser.userId}}</strong> <br />
        </p>
        <pre>{{selectedFleetUser | json}}</pre>
    </div>
</div>